import { ColorEnum } from '@/constants/color'
import { ShiftCloseoutPreviewSource } from '@/features/shiftCloseouts/types'
import { calculateCashTransactionTotals } from '@/features/shiftCloseouts/utils/calculateCashTransactionTotals'
import MinusIcon from '@/features/ui/icons/components/MinusIcon'
import PlusIcon from '@/features/ui/icons/components/PlusIcon'
import Typography from '@/features/ui/typography'
import { formatPrice } from '@/utils/priceHelper'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface CashTransactionsProps {
    currency: string
    transactions: ShiftCloseoutPreviewSource['cashTransactions']
}

const CashTransactions: FC<CashTransactionsProps> = ({ currency, transactions }) => {
    const { t } = useTranslation()
    const totals = calculateCashTransactionTotals(currency, transactions)

    return (
        <View style={styles.section}>
            <Typography.Heading variant="h5" style={styles.sectionHeading}>
                {t('shiftCloseouts.cashTransactions.heading')}
            </Typography.Heading>

            <View style={styles.list}>
                <View style={styles.row}>
                    <View style={styles.label}>
                        <PlusIcon fill={ColorEnum.Emerald600} height={16} width={16} />
                        <Typography.Description font="medium">
                            {t('shiftCloseouts.cashTransactions.deposits')}
                        </Typography.Description>
                    </View>
                    <Typography.Description font="medium">
                        {formatPrice(totals.deposits.amount, totals.deposits.currency, true)}
                    </Typography.Description>
                </View>
                <View style={styles.row}>
                    <View style={styles.label}>
                        <MinusIcon fill={ColorEnum.BRICK_500} height={16} width={16} />
                        <Typography.Description font="medium">
                            {t('shiftCloseouts.cashTransactions.withdrawals')}
                        </Typography.Description>
                    </View>
                    <Typography.Description font="medium">
                        {formatPrice(totals.withdrawals.amount, totals.withdrawals.currency)}
                    </Typography.Description>
                </View>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    section: {
        gap: 8,
    },
    sectionHeading: {
        color: ColorEnum.GRAY_900,
    },
    list: {
        gap: 8,
    },
    row: {
        minHeight: 48,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderColor: ColorEnum.GRAY_200,
        borderRadius: 12,
        borderWidth: 1,
        backgroundColor: ColorEnum.WHITE,
    },
    label: {
        flex: 1,
        minWidth: 0,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
})

export default CashTransactions
